import { createAction, props } from '@ngrx/store';
import { CustomerInfo, PurchasesOfferings, PurchasesPackage } from '@revenuecat/purchases-capacitor';

// Configure
export const configure = createAction(
  '[RevenueCat] Configure'
);


// Load Packages
export const loadPackages = createAction(
  '[RevenueCat] Load Packages'
);

export const loadPackagesSuccess = createAction(
  '[RevenueCat] Load Packages Success',
  props<{ offerings: PurchasesOfferings }>()
);

export const loadPackagesFailure = createAction(
  '[RevenueCat] Load Packages Failure',
  props<{ error: any }>()
);

// Purchase Package
export const purchasePackage = createAction(
  '[RevenueCat] Purchase Package',
  props<{ package: PurchasesPackage }>()
);

export const purchasePackageSuccess = createAction(
  '[RevenueCat] Purchase Package Success',
  props<{ customerInfo: CustomerInfo }>()
);

export const purchasePackageFailure = createAction(
  '[RevenueCat] Purchase Package Failure',
  props<{ error: any }>()
);

// Restore Purchases
export const restorePurchases = createAction(
  '[RevenueCat] Restore Purchases'
);

export const restorePurchasesSuccess = createAction(
  '[RevenueCat] Restore Purchases Success',
  props<{ customerInfo: CustomerInfo }>()
);

export const restorePurchasesFailure = createAction(
  '[RevenueCat] Restore Purchases Failure',
  props<{ error: any }>()
);

// Check Subscription Status
export const checkSubscriptionStatus = createAction(
  '[RevenueCat] Check Subscription Status'
);

export const checkSubscriptionStatusSuccess = createAction(
  '[RevenueCat] Check Subscription Status Success',
  props<{ customerInfo: CustomerInfo }>()
);

export const checkSubscriptionStatusFailure = createAction(
  '[RevenueCat] Check Subscription Status Failure',
  props<{ error: any }>()
);

// Customer Info Updated (listener)
export const updateCustomerInfo = createAction(
  '[RevenueCat] Update Customer Info',
  props<{ customerInfo: CustomerInfo }>()
);


// Customer Info Updated (listener)
export const updateLoginItem = createAction(
  '[RevenueCat] Update Login Item',
  props<{ loginItem: any }>()
);
